<div *ngIf="!isLoading">
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button   id="print-button"  class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
        printSectionId="print-section"  [useExistingCss]="true"  ngxPrint>
      Print
      </button>

      <button (click)="printPage()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
    Print
    </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Advt_Invoice_Register')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>  
   
    <ng-container *ngIf="reportType == 'Briefly'">
        <div class="container" id="print-section"style="margin-top:50px; margin-right: 3px; margin-left: 3px;">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th colspan="12">हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग
                        </th>
                        <th colspan="2">दिनांक - {{ today | date:"dd-MM-yyy" }}</th>
                        <th colspan="2">पृष्ठ क्र.- 1</th>
                    </tr>
                    <tr>
                        <th colspan="4"> Advt Invoice Register</th>
                        <th colspan="3">Briefly</th>
                        <th colspan="3">Date</th>
                        <th colspan="3">From :- {{ startDate | date:"dd-MM-yyy" }}</th>
                        <th colspan="3">To :-  {{ endDate | date:"dd-MM-yyy" }}   </th>
                    </tr>
                    
                    <tr>
                        <th>Invoice No.</th>
                        <th>Invoice Date</th>
                        <th>Advertiser Name</th>
                        <th>Customer Name</th>
                        <th>Issue Name</th>
                        <th>Issue Date</th>
                        <th>Advt<br>Amount</th>
                        <th>Discount<br>Amount</th>
                        <!-- <th>Net Amount</th> -->
                        <th>Amount<br>Before GST</th>
                        <th>CGST</th>
                        <th>SGST</th>
                        <th>IGST</th>
                        <th>Total GST</th>
                        <th>Total<br>Invoice Amount</th>
                        <th>Paid<br>Amount</th>
                        <th>Unpaid<br>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container  *ngFor="let data of filteredAdvtInvoiceDatabrifly; let i = index">
                        <tr>
                            <td>{{ data['invoice_no'] }}</td>
                            <td>{{ data['invoice_date'] }}</td>
                            <td style="font-weight:bold;">{{ data['advt_name'] | slice : 0:30 }}</td>
                            <td>{{ data['cust_name'] }}</td>
                            <td>{{ data['combined_issue_name']  | slice : 0:20 }}</td>
                            <td>{{ data['combined_issue_date'] }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['advt_amt'] }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['discount'] }}</td>
                            <!-- <td class="right text-end" style="text-align: end;">{{ data['net_amt'] }}</td> -->
                            <td class="right text-end" style="text-align: end;">{{ data['beforegst_amt']  }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['cgst'] }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['sgst'] }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['igst'] }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['gst']  }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['invoice_total'] }}</td>
                            <td class="right text-end" style="text-align: end;">{{data.received_amt}}</td>
                            <td class="right text-end" style="text-align: end;">{{data.unpaid_amount }}</td>
            </tr>
            <!-- before_gst_amount_db -->
                    </ng-container>
                   
                </tbody>
             
                    <tr>
                        
                        <td style="text-align:center; font-weight: bold; border-bottom: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;"  colspan="6">Total:</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{advtamount}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{discountamt}}</td>
                        <!-- <td style="font-weight: bold; font-size: 16px; text-align: end;">{{netamount}}</td> -->
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{totalbeforegstamount}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{tcgst}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{tsgst}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{tigst}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{tgst}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{invoice_total}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{paid_amount}}</td>
                        <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{invoice_total - paid_amount }}</td>


                    </tr>
                
            </table>
        </div>
    </ng-container>


  
</div>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>